import { type ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { menuItemsConfig } from './menu-items-config'

export function MenuSkeleton({ className }: { className?: string }): ReactNode {
  return (
    <div
      className={twMerge(
        `flex animate-pulse items-center gap-1`,
        className,
        addPublicCustomClassNamePrefix('desktop-navbar-skeleton'),
      )}
    >
      {Array.from({ length: menuItemsConfig.length }).map((_, index) => (
        <Skeleton key={index} className="h-8 w-25 shrink-0 rounded-md" />
      ))}
    </div>
  )
}
